"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeCheckboxStyles = void 0;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var makeCheckboxStyles = function makeCheckboxStyles(_ref) {
  var primitives = _ref.primitives,
      tokens = _ref.tokens;
  return {
    MuiCheckbox: {
      styleOverrides: {
        root: _objectSpread(_objectSpread({
          padding: "".concat(primitives.spacings["0"], "px"),
          margin: "".concat(primitives.spacings["2"], " 0"),
          outlineOffset: 0
        }, tokens.transitions["state-blur"]), {}, _defineProperty({
          "&.DhigCheckbox--size--small": _defineProperty({
            "& svg": {
              height: primitives.spacings["4"],
              width: primitives.spacings["4"]
            }
          }, "& + [class*=\"MuiFormControlLabel-label\"]", {
            fontSize: primitives.fontSizes[1]
          }),
          "&:hover": {
            backgroundColor: "inherit!important"
          },
          "&:hover > svg": _objectSpread({
            outline: "".concat(primitives.borderWidths.medium, " solid ").concat(tokens.colors["ink-hover"].color)
          }, tokens.transitions["state-activate"]),
          "&:focus, &.Mui-focusVisible, &:focus-visible > svg": _objectSpread({
            outline: "".concat(primitives.borderWidths.large, " solid ").concat(tokens.colors["ink-focus"].color),
            outlineOffset: primitives.borderWidths.medium,
            borderRadius: primitives.borderRadii.small
          }, tokens.transitions["state-activate"]),
          "&:active > svg": _objectSpread({
            outline: "".concat(primitives.borderWidths.large, " solid ").concat(tokens.colors["fill-success"].color)
          }, tokens.transitions["state-activate"]),
          "&.DhigCheckbox--error": _defineProperty({}, "& + [class*=\"MuiFormControlLabel-label\"]", {
            color: tokens.colors["ink-error"].color
          }),
          "&.DhigCheckbox--error > svg": {
            outline: "".concat(primitives.borderWidths.large, " solid ").concat(tokens.colors["ink-error"].color),
            outlineOffset: primitives.borderWidths.medium,
            borderRadius: primitives.borderRadii.small
          },
          '&.Mui-checked:not([class*="MuiCheckbox-indeterminate"])': {
            "& > svg": {
              color: tokens.colors["ink-on-fill-primary"].color,
              background: tokens.colors["fill-primary"].color
            },
            "& span": {
              background: tokens.colors["fill-primary"].color
            }
          },
          "& > svg": {
            height: primitives.spacings["5"],
            width: primitives.spacings["5"],
            padding: "2px",
            border: "".concat(primitives.borderWidths.medium, " solid ").concat(tokens.colors["ink-on-background"].color),
            borderRadius: primitives.borderRadii.small,
            boxSizing: "border-box"
          }
        }, "& + [class*=\"MuiFormControlLabel-label\"]", {
          color: tokens.colors["ink-on-background"].color,
          paddingLeft: primitives.spacings["3"],
          fontSize: primitives.fontSizes["3"],
          lineHeight: primitives.lineHeights.compact
        })),
        colorSecondary: {
          color: "".concat(tokens.colors["ink-on-background"].color, " !important")
        }
      }
    }
  };
};

exports.makeCheckboxStyles = makeCheckboxStyles;